import React from "react";
import "../../App.css";
import NavbarComp from "../navbar/navbar";

const projects = [
  {
    title: "Chico Pantry",
    subtitle: "Open Source Pantry Management Platform",
    stack: "React · JavaScript · Express · PostgreSQL",
    points: [
      <>
        Started Chico Pantry in <span className="project-highlight">Spring 2020</span> as an open source project for California State University, Chico with Jayesh Sathe and Gopal Singh under the supervision of Dr. Kevin Buffardi.
      </>,
      "Built a full stack pantry management system with a React frontend, a JavaScript and Express backend, and PostgreSQL with Sequelize for persistent data management.",
      "Implemented workflows for inventory tracking, student checkout, donation intake, purchase logging, and expiration management to improve day to day pantry administration.",
      "Added reporting and dashboard views for stock levels, item utilization, expired goods, waste, and student activity so staff could make better operational decisions.",
      "Structured the repository for open source development with contribution guidelines, MIT licensing, CI workflows, and containerized local setup for new contributors.",
      <>
        The project later expanded to a <span className="project-highlight">Spring 2023 class of about 40 students</span> and grew into a maintained campus codebase with <span className="project-highlight">633 commits</span> and <span className="project-highlight">52 listed contributors</span> on GitHub.
      </>,
    ],
    link: { href: "https://github.com/ChicoState/PantryNode", label: "GitHub" },
    linkPrefix: "Code",
  },
  {
    title: "Codewit.us",
    subtitle: "Inclusive Learning Platform and Ruby on Rails Backend",
    stack: "Ruby on Rails · PostgreSQL · JavaScript · jQuery",
    points: [
      "Founding developer for Codewit.us, an inclusive platform for sharing unique perspectives in learning how to code.",
      "Supported a funded education initiative backed by the California Governor's Office of Planning and Research Learning Lab, the Department of Education Higher Education Emergency Relief Fund (HEERF II), and the National Science Foundation Broadening Participation in Computing program.",
      "Built core backend systems using Ruby on Rails and PostgreSQL to support learning workflows, content delivery, and persistent application data.",
      "Developed the frontend with HTML, CSS, Bootstrap, JavaScript, jQuery, and AJAX to support interactive programming experiences.",
      "Shipped multiple releases while handling UAT, regression testing, documentation, and defect tracking across the platform lifecycle.",
      <>
        My development contributions to Codewit.us were acknowledged in the ACM
        ITiCSE 2022 paper {" "}
        <a href="https://dl.acm.org/doi/10.1145/3502718.3524778" target="_blank" rel="noreferrer" style={{ color: "#168f7c", textDecoration: "none" }}>
          Integrating Videos with Programming Practice
        </a>.
      </>,
    ],
  },
  {
    title: "Real Time Recommendation Engine",
    subtitle: "Event-Driven Backend and Real-Time Communication",
    stack: "Node.js · Socket.IO · Event-driven architecture · APIs",
    points: [
      "Designed and built a backend system that delivered personalized recommendations for places and activities based on user interactions.",
      "Implemented an event driven architecture to support live user feedback, polling, and dynamic content updates.",
      "Built real time communication features using Socket.IO to enable chat, reviews, and interactive user flows.",
      "Integrated multiple third party APIs to enrich recommendation data and improve relevance.",
      "Focused on low latency request handling and concurrency to support smooth real time user experiences.",
    ],
  },
  {
    title: "COVID 19 Prediction Using Machine Learning",
    subtitle: "Applied Machine Learning and Web Systems",
    stack: "Python · Flask · Machine learning",
    points: [
      "Trained and evaluated multiple machine learning models using public datasets to predict COVID 19 infection likelihood.",
      "Built a Flask based web application to collect user inputs and generate predictions in real time.",
      "Designed the system to support iterative model improvements as new data became available.",
    ],
  },
  {
    title: "Wearable Tracker System",
    subtitle: "Distributed Systems and Embedded Integration",
    stack: "ESP8266 · Bluetooth · RFID · Node.js · MongoDB",
    points: [
      "Designed a wearable tracking system to analyze crowd behavior and movement patterns in amusement park environments.",
      "Architected the solution to support multiple use cases including ride interest analysis, payment integration, and child tracking.",
      "Integrated embedded hardware components with backend services using ESP8266, Bluetooth, RFID, Node.js, and MongoDB.",
    ],
  },
  {
    title: "Real Time CO2 Emission Monitoring Device for Vehicles",
    subtitle: "IoT Systems and Data Automation",
    stack: "IoT sensors · Backend services · Web and mobile apps",
    points: [
      "Designed and developed an IoT based solution to monitor vehicle emission levels in real time.",
      "Automated data collection and reporting workflows using sensors and backend services to support regulatory compliance.",
      "Integrated hardware devices with web and mobile applications for visualization and reporting.",
    ],
  },
  {
    title: "Weather Monitoring Model Rocket and Wireless Launch System",
    subtitle: "Embedded Systems and Telemetry",
    stack: "Arduino · Raspberry Pi · PHP · MySQL",
    points: [
      "Designed a wireless launch control system with a base station to safely trigger rocket deployment.",
      "Built a telemetry system to capture and transmit altitude, pressure, temperature, and speed data during flight.",
      "Implemented backend visualization and storage for post launch data analysis.",
      "Integrated embedded programming, IoT communication, and backend services using Arduino, Raspberry Pi, PHP, and MySQL.",
    ],
  },
];

class Project extends React.Component {
  render() {
    return (
      <div className="container d-flex justify-content-center mt-5">
        <div className="centered-box w-lg-75 w-100">
          <NavbarComp />
          <div className="row">
            <div className="mt-3" id="projects">
              <h5>Projects</h5>
              <hr />
              <ul className="list-group">
                {projects.map((project, index) => (
                  <React.Fragment key={project.title}>
                    <li className="list-group-item">
                      <div className="row mt-4">
                        <div className="col-12 mb-2">
                          <h4>{project.title}</h4>
                          <div className="project-subtitle">{project.subtitle}</div>
                          <div className="project-tech">Stack: {project.stack}</div>
                        </div>
                        <div className="col-12">
                          <ul>{project.points.map((point, pointIndex) => <li key={pointIndex}>{point}</li>)}</ul>
                          {project.link && <p className="mb-0">{project.linkPrefix || "Learn more"}: <a href={project.link.href} target="_blank" rel="noopener noreferrer" style={{ color: "#168f7c", textDecoration: "none" }}>{project.link.label}</a></p>}
                        </div>
                      </div>
                    </li>
                    {index < projects.length - 1 && <hr />}
                  </React.Fragment>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Project;
